var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['guest', 'both'].includes(_vm.user.type) && _vm.userHasGuest)?_c('GuestBookingOptions',{on:{"saved":function($event){_vm.guestBookingOptionsSaved = true}}}):_vm._e(),(['show', 'both'].includes(_vm.user.type) && _vm.userHasShow)?_c('ShowBookingOptions',{on:{"saved":function($event){_vm.showBookingOptionsSaved = true}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }